import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { all, put, select, takeEvery } from 'redux-saga/effects';
import { setCompliantLocalStorageItem } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/actions';
import { CompliantLocalStorageKeys } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/constants';
import { removeEditorDraft, saveEditorDraft } from './actions';
import { EDITOR_DRAFT_EXPIRATION_DELTA } from './constants';
import { getEditorDraftsState } from './selectors';
function cleanExpiredDrafts(draftsState) {
    const newState = {};
    for(const editorId in draftsState){
        const { updatedAt } = draftsState[editorId];
        const minUpdatedDate = Date.now() - EDITOR_DRAFT_EXPIRATION_DELTA;
        if (updatedAt >= minUpdatedDate) {
            newState[editorId] = draftsState[editorId];
        }
    }
    return newState;
}
function* saveEditorDraftHandler({ payload: { editorId, editorState } }) {
    if (!editorState) {
        return;
    }
    const data = {
        editorState,
        updatedAt: Date.now()
    };
    const draftsState = yield select(getEditorDraftsState) || {};
    const mergedDraftsState = _object_spread_props(_object_spread({}, cleanExpiredDrafts(draftsState)), {
        [editorId]: data
    });
    yield put(setCompliantLocalStorageItem({
        key: CompliantLocalStorageKeys.EDITOR_DRAFTS,
        value: JSON.stringify(mergedDraftsState)
    }));
}
function* removeEditorDraftHandler({ payload: { editorId } }) {
    const draftsState = yield select(getEditorDraftsState) || {};
    delete draftsState[editorId];
    yield put(setCompliantLocalStorageItem({
        key: CompliantLocalStorageKeys.EDITOR_DRAFTS,
        value: JSON.stringify(draftsState)
    }));
}
export function* draftsSaga() {
    yield all([
        takeEvery(saveEditorDraft, saveEditorDraftHandler),
        takeEvery(removeEditorDraft, removeEditorDraftHandler)
    ]);
}

//# sourceMappingURL=saga.js.map